import { buildHref } from '@shared/utils/url';
import { AUTO_EDIT_QUERY_PARAM, AUTO_EDIT_QUERY_VALUE } from '@modules/items/constants';
import { CHANGE_TEMPLATE_VERSION_PARAM } from './constants';
import { EChangeTemplateSection } from './types';

export const CHANGE_TEMPLATES_PATH = '/change-templates';
type TChangeTemplatePathTarget = {
  section?: EChangeTemplateSection;
  assessmentId?: string;
  templateVersion?: string;
  // Template edit mode: the next document starts editing by itself.
  autoEdit?: boolean;
};

// General is the index route, so its path has no section.
export const getChangeTemplatePath = (
  id: string,
  { section, assessmentId, templateVersion, autoEdit }: TChangeTemplatePathTarget = {}
) => {
  let pathname = `/change-template/${id}`;
  if (assessmentId) pathname += `/${EChangeTemplateSection.ASSESSMENTS}/${assessmentId}`;
  else if (section && section !== EChangeTemplateSection.GENERAL) pathname += `/${section}`;
  return buildHref(pathname, {
    [CHANGE_TEMPLATE_VERSION_PARAM]: templateVersion,
    [AUTO_EDIT_QUERY_PARAM]: autoEdit ? AUTO_EDIT_QUERY_VALUE : undefined,
  });
};
